import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Table} from '@core/components';
import {PlanRiskComparisonRow, RiskDeclarationRow, SurveyQuestion, SurveyRow} from '@core/types';
import {Confirm} from '@core/modals';
import {ModalService} from '@core/services';

@Component({
  selector: 'core-plan-results',
  imports: [
    Table
  ],
  templateUrl: './plan-results.html',
  styleUrl: './plan-results.scss',
  standalone: true,
  host: {
    style: 'width: 100%;display:flex;flex-direction:column;gap:2rem'
  }
})
export class PlanResults {

  @Output() submit = new EventEmitter();
  @Input() frozenRiskSnapshot: PlanRiskComparisonRow[] = [];
  @Input() riskComparison: PlanRiskComparisonRow[] = [];
  @Input() surveys: SurveyRow[] = [];
  @Input() declarations: RiskDeclarationRow[] = [];
  isSubmittingPhase = false;
  private modal = inject(ModalService);

  async onSubmit() {
    if (this.isSubmittingPhase) return;
    this.isSubmittingPhase = true;
    const confirmed = await this.askForConfirmation(
      'AVISO - SALIR DE FASE 2',
      'Al continuar a la Fase 3 ya no podrás volver a la monitorización de resultados. Las encuestas pendientes de respuesta seguirán recogiéndose en segundo plano. ¿Continuar?',
      'Continuar'
    );
    if (!confirmed) {
      this.isSubmittingPhase = false;
      return;
    }
    this.submit.emit();
    this.isSubmittingPhase = false;
  }

  surveyQuestions(item: SurveyRow): SurveyQuestion[] {
    return item.questions || [];
  }

  riskValue(item: PlanRiskComparisonRow, mode: 'frozen' | 'current'): number {
    const raw = mode === 'frozen' ? Number(item.current || 0) : Number(item.current || 0);
    if (!Number.isFinite(raw)) return 0;
    return Math.max(0, Math.min(100, raw));
  }

  private askForConfirmation(title: string, description: string, confirmText: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.modal.open<Confirm, boolean>(Confirm, {
        inputs: {
          title,
          description,
          confirmText,
          cancelText: 'Cancelar',
        },
        outputs: {
          close: () => resolve(false),
          confirm: () => resolve(true),
        },
        options: { size: 'md', closeOnBackdrop: true },
      });
    });
  }
}
